<template>
  <header class="header-table-validator">
    <div class="h2-text title-table-validators">Validators</div>
    <!--<SubHeaderButton class="float-right" :item="btnAddValidator"> </SubHeaderButton>-->
  </header>
</template>
<script>
import SubHeaderButton from '../globalSettings/SubHeaderButton';
import consts from '../../../_consts';

export default {
  name: 'subHeaderUserManagement',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    SubHeaderButton
  },
  data () {
    return {
      btnAddValidator: consts.subHeaderBtn.addValidator
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.header-table-validator{
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.subHeader{
  margin-top: 3px;
}

.content-header{
  width: 250px;
}

.float-left{
  float: left;
}

.float-right{
  float: right;
}
</style>



// WEBPACK FOOTER //
// SubHeaderGlobalSettings.vue?23f19a15